module.exports = __webpack_public_path__ + "static/media/accept-button.ca431b4b.png";